import React, { Component, Fragment } from "react";
import InputLabel from '@material-ui/core/InputLabel';
import './InviteUserModal.css';
import { Icon } from '@material-ui/core';
import trim from 'lodash/trim';
import uuid from "uuid/v4";
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
const emailRegEx = /\S+@\S+\.\S+/;

class EmailTagsInput extends Component {
    state = {
        emailAddress: '',
    }

    handleInputChange = (event) => {
        if (event.target.value !== ',' && this.props.emailAddresses.length < 10) {
            this.setState({ emailAddress: trim(event.target.value) });
        }
    }

    onEmailBlur = (event) => {
        if (this.props.emailAddresses.length < 10 && !isEmpty(event.target.value)) {
            const { value } = event.target;
            this.setState({ emailAddress: '' }, () => {
                const { emailAddresses } = this.props;
                this.props.setEmailAddresses([...emailAddresses, { val: value, isEmail: emailRegEx.test(value) }]);
            })
        }
    }

    onKeyPress = (event) => {
        if (event.keyCode === 188 && this.props.emailAddresses.length < 10) {
            const { value } = event.target;
            this.setState({ emailAddress: '' }, () => {
                const { emailAddresses } = this.props;
                this.props.setEmailAddresses([...emailAddresses, { val: value, isEmail: emailRegEx.test(value) }]);
            })
        }

        let { emailAddress } = this.state,
            { emailAddresses } = this.props;
        if (event.keyCode === 8 && emailAddresses.length && !emailAddress.length) {
            this.props.setEmailAddresses(emailAddresses.slice(0, emailAddresses.length - 1));
        }
    }

    handleRemoveItem = (index) => {
        let { emailAddresses } = this.props;
        this.props.setEmailAddresses(emailAddresses.filter((item, i) => i !== index));
    }

    render() {
        const { emailAddresses, emailsValid } = this.props;
        return (
            <Fragment>
                <InputLabel
                    htmlFor="custom-css-input"
                >
                    Email address(es)
                </InputLabel>
                {!emailsValid ? (
                    <span className='email-error'>
                        Invalid email address. Please make sure that all addresses are properly formed.
                    </span>
                ) : null
                }
                <ul style={!emailsValid ? { border: '1px solid #e01607' } : {}} className='address-container'>
                    {emailAddresses.map((item, idx) =>
                        <li key={uuid()} className={!item.isEmail ? 'email-item invalid-item' : 'email-item'} onClick={() => this.handleRemoveItem(idx)}>
                            {item.val}
                            <Icon style={{ fontSize: '17px', margin: '2px 2px 2px 3px', opacity: '0.7' }}>close</Icon>
                        </li>
                    )}
                    <input
                        id="custom-css-input"
                        onBlur={this.onEmailBlur}
                        onChange={this.handleInputChange}
                        value={this.state.emailAddress}
                        onKeyDown={this.onKeyPress}
                        style={{ display: 'inline-block', flex: '2' }}
                    />
                </ul>
                <span className='email-helper-text'>
                    *Enter up to 10 email addresses, separated by a comma.
                </span>
            </Fragment>
        )
    }
}

EmailTagsInput.propTypes = {
    setEmailAddresses: PropTypes.func.isRequired,
    emailAddresses: PropTypes.array.isRequired,
    emailsValid: PropTypes.bool
}

export default EmailTagsInput;


// WEBPACK FOOTER //
// ./src/main/content/user-management/EmailTagsInput.js